import type { ComponentType } from "react";

export function compose<P = unknown, E = unknown>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...fns: Array<(arg: any) => any>
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <C extends ComponentType<any>>(component: C): ComponentType<P & E> => {
    return fns.reduceRight((acc, fn) => fn(acc), component) as ComponentType<
      P & E
    >;
  };
}

export default compose;
